import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button, TextField, Typography} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {config} from "../../../constant";

export default function DialogEditArchivePerson({open, onClose, archivePersonId}) {
    const [fetched, setFetched] = useState(false);
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required("Prénom est obligatoire"),
        firstYear: Yup.number("Première année doit être numérique").transform(value => (Number.isNaN(value) ? undefined : value)),
        lastYear: Yup.number("Dernière année doit être numérique").transform(value => (Number.isNaN(value) ? undefined : value)).nullable(),
    });

    const {register, reset, control, handleSubmit, formState: {errors}} = useForm({
        resolver: yupResolver(validationSchema)
        // defaultValues: {
        //     firstName: '',
        //     lastName: '',
        //     firstYear: '',
        //     lastYear: ''
        // }
    });

    const onSubmit = (data) => {
        const requestOptions = {
            method: archivePersonId === null ? 'POST' : 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };
        fetch(`${config.BASE_URL}/archive-people`, requestOptions)
            .then(response => {
                onClose(true);
            })
            .catch((error) => {
                const message = 'Erreur dans la création ou mise à jour d\'une personne archive';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    useEffect(() => {
        if (archivePersonId) {
            fetch(`${config.BASE_URL}/archive-people/${archivePersonId}`)
                .then(response => response.json())
                .then(data => {
                    reset(data);
                    setFetched(true);
                })
                .catch((error) => {
                    const message = 'Erreur dans la récupération de la personne archive';
                    console.error(message, error);
                    navigate("/error", {state: {message: message}});
                });
        }
    }, []);

    return (
        <Dialog open={open} onClose={() => onClose(false)} maxWidth={'lg'}>
            <DialogTitle>Personne archive</DialogTitle>
            <DialogContent>
                {(!archivePersonId || fetched) && (
                    <form id="archivePersonForm" onSubmit={handleSubmit(onSubmit)}>
                        <TextField
                            margin="dense"
                            id="firstName"
                            name="firstName"
                            label="Prénom"
                            fullWidth
                            variant="standard"
                            {...register("firstName")}
                            error={!!errors.firstName}
                            // InputLabelProps={{
                            //     shrink: true
                            // }}
                        />
                        <Typography variant="inherit" color="textSecondary">{errors.firstName?.message}</Typography>

                        <TextField
                            margin="dense"
                            id="lastName"
                            name="lastName"
                            label="Nom"
                            fullWidth
                            variant="standard"
                            {...register("lastName")}
                            error={!!errors.lastName}
                        />
                        <Typography variant="inherit" color="textSecondary">{errors.lastName?.message}</Typography>

                        <TextField
                            type="number"
                            margin="dense"
                            id="firstYear"
                            name="firstYear"
                            label="Première participation"
                            fullWidth
                            variant="standard"
                            {...register("firstYear")}
                            error={!!errors.firstYear}
                        />
                        <Typography variant="inherit" color="textSecondary">{errors.firstYear?.message}</Typography>

                        <TextField
                            type="number"
                            margin="dense"
                            id="lastYear"
                            name="lastYear"
                            label="Dernière participation"
                            fullWidth
                            variant="standard"
                            {...register("lastYear")}
                            error={!!errors.lastYear}
                        />
                        <Typography variant="inherit" color="textSecondary">{errors.lastYear?.message}</Typography>
                    </form>
                )}
            </DialogContent>
            <DialogActions>
                <Button type="submit" form="archivePersonForm">OK</Button>
                <Button onClick={() => onClose(false)}>Annuler</Button>
            </DialogActions>
        </Dialog>
    );
}
